import React, { FunctionComponent } from 'react';
import { Editorial, PageWrapper } from 'components/presentional';
import { Redirect, useParams } from 'react-router-dom';
import { usePages } from 'hooks';
import { Block, BlockContent } from 'components/elements';
import { useRouteTranslations } from 'utils';

interface OwnProps {}

type EditorialPageProps = JSX.IntrinsicElements['article'] & OwnProps;

const EditorialPage: FunctionComponent<EditorialPageProps> = props => {
  let { pageId } = useParams<any>();
  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages({ slug: pageId });

  if (!pageId) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  const [customPage] = page || [];

  if (!page) {
    return null;
  }

  if (!customPage) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={'editorial'}>
      <Block id="editorial" data-module="editorial">
        <BlockContent direction="row">{customPage && <Editorial data={customPage} />}</BlockContent>
      </Block>
    </PageWrapper>
  );
};

export default EditorialPage;
